var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncognito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.666,
    cy: 64,
    r: 56,
    fill: "#FEF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.666 32L114.666 32",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 82L17.666 82",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.666 39L112.666 39",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66602 89L15.666 89",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 32H125.666",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6299 57.0137C77.3021 57.0137 85.6008 59.5618 92.4519 62.0267H37.9035C44.8954 59.5618 53.31 57.0137 65.6299 57.0137Z",
    fill: "#E9688A",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.2391,
    cy: 79.5526,
    r: 9.94714,
    stroke: "#E9688A",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.579,
    cy: 79.5526,
    r: 9.94714,
    stroke: "#E9688A",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.543 78.4074C58.543 78.4074 61.9771 77.2627 65.4113 77.2627C68.8454 77.2627 72.2795 78.4074 72.2795 78.4074",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8282 35.7717L89.8694 53.3747C90.0281 53.7712 89.7058 54.1936 89.2823 54.138C85.8112 53.6827 73.514 52.151 65.178 52.151C56.8419 52.151 44.5444 53.6828 41.0736 54.138C40.6501 54.1936 40.3279 53.7714 40.4864 53.3748L47.5231 35.7728C48.434 33.4942 50.6405 32 53.0944 32H77.2574C79.7108 32 81.917 33.4937 82.8282 35.7717Z",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognito);
export default __webpack_public_path__ + "static/media/incognito.cbd0b3afca3bcd10d63a60d92ae594a4.svg";
export { ForwardRef as ReactComponent };